<template>
  <div class="projects-categories">
    <ul class="projects-categories__list">
      <li
        class="projects-categories__item"
        v-for="(category, index) in categories"
        :key="`category-${index}`"
      >
        <router-link v-if="category.route" :to="category.route">
          <span>{{ category.title }}</span>
        </router-link>

        <a
          href="#"
          v-else-if="category.showItems"
          @click.prevent.stop="handleClick(category)"
        >
          <span>{{ category.title }}</span>
        </a>

        <div v-else>
          <span>{{ category.title }}</span>
          <ul>
            <li v-for="item in category.items" :key="item.text">
              <router-link :to="item.route">
                <span>{{ item.text }}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'TheProjectsCategories',
  props: {
    categories: {
      type: Array,
      required: true
    }
  },
  methods: {
    ...mapActions('page', [
      'updateCategoryIndex'
    ]),
    handleClick (category) {
      this.$emit('select', category)
      this.updateCategoryIndex(category.index)
    }
  }
}
</script>

<style lang="scss">
.projects-categories{
  width: 100%;

  // List

  &__list{
    @include no-type-list;
    @include media("large"){
      max-width: 60rem;
    }
  }

  // Item

  &__item{
    @include media("small"){
      font-size: 1.6rem;
    }
    @include media("medium-large"){
      font-size: 1.8rem;
    }

    padding-bottom: 2.5rem;
    color: white;

    a{
      @include add-transition;
      @include media("large"){
        @include add-hover-underline;
      }
      @include hover{
        > span{
          color: rgba(white, 1);
        }
      }
      margin: 0;
      display: inline-block;
      text-decoration: none;

      > span{
        @include add-transition;
        font-size: 2.5rem;
        font-family: get($font-families, 'secondary');
        color: rgba(white, 0.3);
      }
    }

    div > span{
      font-size: 2.5rem;
      font-family: get($font-families, 'secondary');
      color: rgba(white, 0.3);
    }

    div ul{
      @include no-type-list;
      margin-left: layout("spacing");
      margin-top: 2rem;
      margin-bottom: 1rem;

      a{
        padding: 0.6rem 0;
      }
      span{
        font-size: 2rem;
      }
    }
  }

  &__subcategories{
    > span{
      font-size: 2.5rem;
      font-family: get($font-families, 'secondary');
      color: rgba(white, 0.3);
    }

    ul{

      // li > a{
      //   font-size: 2.3rem;
      //   font-family: get($font-families, 'secondary');
      //   color: rgba(white, 0.3);
      //   text-decoration: none;
      // }
    }
  }
}
</style>
